import { Fragment, useMemo } from "react";
import { useSelector } from "react-redux";
import { selectDrillDownItems } from "../../../../store/selectors/drilldownSelectors";
import DrillDownPageContainer from "./DrillDownPageContainer";

interface Props {
  reportId: string;
}
export default function DrillDownEntry({ reportId }: Props) {
  const items = useSelector(selectDrillDownItems);
  const relevantItems = useMemo(() => items.filter((item) => item.reportId === reportId), [items, reportId]);

  if (!relevantItems || relevantItems.length === 0) {
    return <></>;
  }

  return (
    <Fragment key="drilldownpages">
      {relevantItems.map((item, index) => (
        <DrillDownPageContainer key={item.pageId} page={item} index={index} />
      ))}
    </Fragment>
  );
}
